import { useMemo } from 'react';
import { Table } from '@/components';
import { useServices } from '../hooks';
import { servicesTableColumns } from '../config';
import { ServicesFilter } from '../models';

interface ServicesTableProps {
  filters: ServicesFilter;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  renderActions: (rowData: Record<string, any>) => React.ReactNode;
}

const ServicesTable = ({
  filters,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  renderActions,
}: ServicesTableProps) => {
  
  const { services, totalItems, totalPages, isLoading } = useServices({
    filters: {
      name: filters.name || undefined,
      businessId: filters.commercialBusinessId || undefined,
      serviceTypeId: filters.serviceTypeId || undefined,
      vehicleTypeId: filters.vehicleTypeId || undefined,
    },
    page,
    pageSize,
  });

  const columns = useMemo(() => servicesTableColumns, []);

  return (
    <div className="w-full p-5 flex flex-col bg-white rounded-lg shadow-md gap-5">
      <Table
        data={services}
        columns={columns}
        isLoading={isLoading}
        renderActions={renderActions}
        pagination={{
          totalItems,
          totalPages,
          currentPage: page,
          rowsPerPage: pageSize,
          onPageChange,
          onRowsPerPageChange: onPageSizeChange,
        }}
      />
    </div>
  );
};

export default ServicesTable;
